import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Nav } from 'reactstrap';

import ProfileMenu from '../ProfileMenu';

import { defaultLogo } from '../../helpers/App';

const UploadPageHeader = ({ uploadPage, notFound }) => {
  if (!uploadPage && !notFound) {
    return null;
  }

  if (notFound) {
    return (
      <div className="share-header upload-header">
        <Link to="/" className="share-logo">
          <img src={defaultLogo} alt="Stockpress" />
        </Link>
      </div>
    );
  }

  return (
    <div className="share-header upload-header toolbar">
      <Link to="/" className="share-logo upload-logo">
        <img src={uploadPage.logo_url} alt={uploadPage.client?.name} />
      </Link>
      <div className="nav-actions navbar-expand">
        <Nav className="ml-auto upload-actions" navbar>
          <ProfileMenu />
        </Nav>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  uploadPage: state.UploadPages.uploadPage,
});

UploadPageHeader.propTypes = {
  uploadPage: PropTypes.object,
  notFound: PropTypes.bool,
};

UploadPageHeader.defaultProps = {
  uploadPage: null,
  notFound: false,
};

export default connect(mapStateToProps)(UploadPageHeader);
